<!--
 * @Function: 我的试卷
-->

<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">

        <a-row :gutter="12" style="margin:0px 0px 16px 0px;">
          <a-col class="a-large-form" >
            <a-form-item label="" style="margin-bottom:0px;width:100%">
              <j-input placeholder="试卷名称" v-model="queryParam.paperName"></j-input>
            </a-form-item>
          </a-col>
          <a-col class="a-large-form" >
            <a-form-item
              style="margin-bottom:0px;"
              label=""
              :required="false"
            >
              <j-dict-select-tag v-model="queryParam.subject" placeholder="所属科目" dictCode="subject" />
            </a-form-item>
          </a-col>
          <a-col class="a-large-form" >
            <a-form-item
              style="margin-bottom:0px;"
              label=""
              :required="false"
            >
              <j-dict-select-tag v-model="queryParam.paperType" placeholder="试卷类型" dictCode="paper_type" />
            </a-form-item>
          </a-col>
          <a-button type="primary" @click="searchQuery" style="margin-left:5px;vertical-align: middle;">筛选</a-button>
          <a-button type="primary" @click="searchQuery" style="margin-left:5px;vertical-align: middle;">重置</a-button>
          <a-button @click="examCreate()" type="primary" icon="plus" style="float:right;" >创建试卷</a-button>
        </a-row>
      </a-form>
    </div>
    <div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record" style="width:200px">

          <a @click="examEdite(record.id)">编辑试卷</a>
          <a-divider type="vertical" />
          <a @click="exerciseRecord(record.id)">练习记录</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>

        </span>

      </a-table>
    </div>
    <!-- <teacher-role-modal ref="modalUserRole"></teacher-role-modal> -->

  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  // import { updateShelf } from '@/api/api'

  export default {
    name: 'ExamList',
    mixins: [JeecgListMixin],
    components: {
    },
    data () {
      return {
        description: '试卷列表',
        sex: '0',
        queryParam: {
          realname: '',
          phone: ''
        },
        // 表头
        columns: [

          {
            title: '试卷编号',
            align: 'center',
            dataIndex: 'orgCode',
            width: 100,
            customRender: (text, row, index) => {
              return (<span >{index + 1}</span>)
            }
          },
          {
            title: '试卷名称',
            align: 'center',
            dataIndex: 'paperName',
            width: 250
          },
          {
            title: '所属科目',
            align: 'center',
            dataIndex: 'subject_dictText',
            width: 100
          },
          {
            title: '试卷类型',
            align: 'center',
            dataIndex: 'paperType_dictText',
            width: 100

          },
          {
            title: '难度系统',
            align: 'center',
            dataIndex: 'difficulty_dictText',
            width: 100

          },
          {
            title: '更新人',
            align: 'center',
            dataIndex: 'updateBy',
            width: 100,
            customRender: function (text, record) {
              if (record.updateBy_dictText) {
                return record.updateBy_dictText
              } else {
                return record.createBy_dictText
              }
            }
          },

          {
            title: '更新时间',
            align: 'center',
            dataIndex: 'updateTime',
            customRender: function (text, record) {
              if (text) {
                return text
              } else {
                return record.createTime
              }
            },
            width: 100
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            scopedSlots: { customRender: 'action' },
            width: 260
          }
        ],
        dataSource: [
          {}
        ],
        // 请求参数
    	  url: {
          list: "/exercise/elinkxExamPaper/list",
          delete: "/exercise/elinkxExamPaper/delete",
          deleteBatch: "/exercise/elinkxExamPaper/deleteBatch",
          exportXlsUrl: "/exercise/elinkxExamPaper/exportXls",
          importExcelUrl: "exercise/elinkxExamPaper/importExcel",
          }
        }
      },
      computed: {
        importExcelUrl: function() {
          return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
        }
      },

    methods: {
      // 练习记录
      exerciseRecord (id) {
        this.$router.push({ path: '/exerciseManage/exerciseRecordList?id='+id })
      },
       // 创建试卷
      examCreate() {
        this.$router.push({ path: '/exerciseManage/createExam' })
      },
       // 编辑试卷
      examEdite(id, type) {
        this.$router.push({ path: '/exerciseManage/createExam?id='+id })
      },
      // handlePerssion: function(roleId, sysOrgCode) {
      //   this.$refs.modalUserRole.show(roleId, sysOrgCode)
      // }

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>

<style lang="scss" scoped >

</style>
